import { Injectable } from '@angular/core';
import { LanguageService } from '../../../core/services/language/language.service';
import { ClinicDetailQuery } from '../clinic-detail/clinic-detail.query';
import { SettingsQuery } from '../settings/settings.query';
import { UserQuery } from '../user/user.query';

import { CheckoutWizardService } from '../checkout-wizard/checkout-wizard.service';
import { PaymethodWizardQuery } from '../paymethod-wizard/paymethod-wizard.query';
import { ProductWizardQuery } from '../product-wizard/product-wizard.query';
import { TreatmentWizardSettingsQuery } from '../treatment-wizard-settings/treatment-wizard-settings.query';
import { CheckoutWizardSettingsQuery } from './checkout-wizard-settings.query';
import { CheckoutWizardSettingsStore } from './checkout-wizard-settings.store';
import { PaymentWizardSettingsQuery } from '../payment-wizard-settings/payment-wizard-settings.query';
import { GiftVoucherFormService } from '../gift-voucher-form/gift-voucher-form.service';

@Injectable({ providedIn: 'root' })
export class CheckoutWizardSettingsService {
    constructor(
        private checkoutWizardSettingsStore: CheckoutWizardSettingsStore,
        private checkoutWizardService: CheckoutWizardService,
        private languageService: LanguageService,
        private settingsQuery: SettingsQuery,
        private clinicDetailQuery: ClinicDetailQuery,
        private userQuery: UserQuery,
        private paymethodWizardQuery: PaymethodWizardQuery,
        private checkoutWizardSettingsQuery: CheckoutWizardSettingsQuery,
        private productWizardQuery: ProductWizardQuery,
        private treatmentWizarSettingsQuery: TreatmentWizardSettingsQuery,
        private paymentWizardSettingsQuery: PaymentWizardSettingsQuery,
        private giftVoucherFormService: GiftVoucherFormService,
    ) {}

    /*-----------*/
    /** UPDATES */
    /*----------*/

    seturlCheckout(newUrlCheckout: string) {
        this.checkoutWizardSettingsStore.update({
            urlCheckout: newUrlCheckout,
        });
    }

    /*------------*/
    /** SERVICIOS */
    /*------------*/

    createUrlCheckoutByTreatment() {
        const paymethod = this.paymethodWizardQuery.getActive();
        const systemKey = this.settingsQuery.systemKeyURL;
        const locale = this.languageService.getLocale();
        const tokenId = this.userQuery.tokenId;
        const clinicId = this.clinicDetailQuery.id;

        /** Los servicios seleccionados los cogemos de Akita */
        const productsWithUnitsId: any = [];
        const productsWithUnitsUnits: any = [];
        this.productWizardQuery
            .getAll({
                filterBy: ({ unitsCart }) => unitsCart > 0,
            })
            .forEach((product) => {
                productsWithUnitsId.push(product.id);
                productsWithUnitsUnits.push(product.unitsCart);
            });

        const shippingChoiceUser = this.treatmentWizarSettingsQuery
            .cancelShippingUserChecked
            ? '0'
            : this.treatmentWizarSettingsQuery.confirmShippingUserChecked
            ? '-1'
            : '';

        const shippingAddress =
            this.treatmentWizarSettingsQuery.shippingEnabled !== 0
                ? encodeURIComponent(
                      this.treatmentWizarSettingsQuery.shippingAddress
                  )
                : '';

        let urlCheckout = `${
            paymethod!.url
        }?c=summary&SystemKey=${systemKey}&Locale=${locale}&ClientToken=${tokenId}&ClinicID=${clinicId}&Products=${productsWithUnitsId.join(
            ','
        )}&ProductUnits=${productsWithUnitsUnits.join(',')}&PayMethodID=${
            paymethod!.id
        }&Shipping=${shippingChoiceUser}&ShippingAddress=${shippingAddress}${this.giftVoucherFormService.buildUrlParameters()}`;
    
        this.checkoutWizardSettingsStore.update({
            urlCheckout,
        });

        this.checkoutWizardService.getCheckoutData(urlCheckout, false);
    }

    createUrlCheckoutByAppointment(useDeposit: boolean = false) {
        const paymethod = this.paymethodWizardQuery.getActive();
        const systemKey = this.settingsQuery.systemKeyURL;
        const locale = this.languageService.getLocale();
        const tokenId = this.userQuery.tokenId;
        const clinicId = this.clinicDetailQuery.id;
        const productList = this.paymentWizardSettingsQuery.productList;

        const urlCheckout = `${paymethod!.url}?c=summary&SystemKey=${systemKey}&Locale=${locale}&ClientToken=${tokenId}&ClinicID=${clinicId}&Products=${productList}&PayMethodID=${paymethod!.id}&UseDeposit=${useDeposit ? '-1' : '0'}${this.giftVoucherFormService.buildUrlParameters()}`;
        this.checkoutWizardSettingsStore.update({
            urlCheckout
        });

        this.checkoutWizardService.getCheckoutData(urlCheckout, useDeposit);
    }

    resetUrlCheckout() {
        this.checkoutWizardSettingsStore.update({
            urlCheckout: ''
        });
    }

    resetStore() {
        this.checkoutWizardSettingsStore.reset();
    }
}
